"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var const_1 = require("./util/const");
var vf_scene_1 = require("./vf-scene");
var vf_config_manager_1 = require("./util/vf-config-manager");
var logger_1 = require("./util/logger");
var VFDefaultOrbitScene = (function (_super) {
    __extends(VFDefaultOrbitScene, _super);
    function VFDefaultOrbitScene() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VFDefaultOrbitScene.prototype.prepareModelMesh = function (mesh) {
        _super.prototype.prepareModelMesh.call(this, mesh);
        mesh.cullingStrategy = babylonjs_1.AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION;
    };
    VFDefaultOrbitScene.prototype.initCameraPosition = function () {
        var settingsLoaded = false;
        if (this.model.hasProperties) {
            var scene = this.model.properties["scene"];
            if (scene != null) {
                this.camera.position = new babylonjs_1.Vector3(scene.camera_center.x, scene.camera_center.y, scene.camera_center.z);
                this.camera.lowerRadiusLimit = scene.camera_distance_min;
                this.camera.upperRadiusLimit = scene.camera_distance_max;
                this.camera.radius = scene.camera_distance_start;
                if (scene.camera_yaw_min !== 0 && scene.camera_yaw_max !== 0) {
                    this.camera.lowerAlphaLimit = babylonjs_1.Tools.ToRadians(scene.camera_yaw_min);
                    this.camera.upperAlphaLimit = babylonjs_1.Tools.ToRadians(scene.camera_yaw_max);
                }
                this.camera.lowerBetaLimit = babylonjs_1.Tools.ToRadians(90 - scene.camera_pitch_max);
                this.camera.upperBetaLimit = babylonjs_1.Tools.ToRadians(90 - scene.camera_pitch_min);
                this.camera.target = new babylonjs_1.Vector3(scene.camera_center.x, scene.camera_center.y, scene.camera_center.z);
                settingsLoaded = true;
                this.camera.beta = babylonjs_1.Tools.ToRadians(90 - scene.camera_pitch_start);
                this.camera.alpha = babylonjs_1.Tools.ToRadians(90 - scene.camera_yaw_start);
                this.camera.radius = scene.camera_distance_start;
            }
        }
        if (!settingsLoaded) {
            var cameraPosition = this.model.getCenter().clone();
            var initialAlpha = babylonjs_1.Angle.FromDegrees(vf_config_manager_1.default.GetConfig().initialCameraAlpha).radians();
            var initialBeta = babylonjs_1.Angle.FromDegrees(vf_config_manager_1.default.GetConfig().initialCameraBeta).radians();
            var flyInRadius = this.camera.upperRadiusLimit;
            cameraPosition.addInPlace(new babylonjs_1.Vector3(Math.sin(initialAlpha) * flyInRadius, Math.sin(initialBeta) * flyInRadius, flyInRadius));
            this.camera.position = cameraPosition;
            this.camera.radius = flyInRadius;
            this.camera.setTarget(this.model.getRoot());
        }
        if (this.model.panningEnabled()) {
            logger_1.default.debug("PANNING enabled");
            this.camera.panningSensibility = const_1.default.CAMERA_PAN_SENSIBILITY;
            if (this.model.largestSize > 150) {
                this.camera.panningSensibility *= 150 / this.model.largestSize;
            }
        }
        else {
            logger_1.default.debug("PANNING disabled");
            this.camera.panningAxis = babylonjs_1.Vector3.Zero();
            this.camera.panningSensibility = 0;
        }
        this.camera.panningDistanceLimit = this.model.largestSize / 2;
        this.camera.onMeshTargetChangedObservable.addOnce(function () {
            this.freeze();
        }.bind(this));
    };
    return VFDefaultOrbitScene;
}(vf_scene_1.default));
exports.default = VFDefaultOrbitScene;
